
import { defineComponent } from 'vue';
import ReturnOptions from '@/components/ReturnOptions.vue';
import { UnauthorizedResponseTypes } from '@/types/ApiDtos/EleosAuthenticationResponseDto';
import { isNullOrUndefined, getDirectContactTitle } from '@/shared/helpers';
import globalConstants from '@/shared/globalConstants';

const { knight, swift } = globalConstants.companies;

export default defineComponent({
    name: 'Unauthorized',
    components: {
        ReturnOptions,
    },
    props: {
        company: {
            type: String,
            required: false,
            default: undefined,
        },
    },
    computed: {
        contact() {
            return getDirectContactTitle();
        },
        isSessionTimeout(): boolean {
            const type = this.$route.query?.type;

            if (!isNullOrUndefined(type)) {
                const authType = parseInt(type as string);
                return (
                    authType === UnauthorizedResponseTypes.Expired ||
                    authType === UnauthorizedResponseTypes.NotFound
                );
            }

            return false;
        },
        returnApp(): string {
            if (this.company === knight) {
                return 'KT Mobile';
            } else if (this.company === swift) {
                return 'Pointe';
            } else {
                return '';
            }
        },
    },
});
